export const Config = {
    defaultSize: 614,
    backgroundColor: 0xffffff
};